class UpdateFacility {
	constructor(
		public readonly organizationId: number,
		public readonly facilityId: number,
		public readonly name: string,
		public readonly address: string | null,
		public readonly phoneNumber: string | null,
	) {
		Object.freeze(this);
	}

	// `organizationId` and `facilityId` are route identifiers: neither is echoed in the request body.
	toJSON(): Record<string, unknown> {
		return {
			name: this.name,
			address: this.address,
			phoneNumber: this.phoneNumber,
		};
	}
}

export default UpdateFacility;
